import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { Title, Text } from 'components/atoms';
import { Layout, DiffViewer } from 'components/organisms';


const EditorDiff = memo(({ oldCode, newCode, hasEdited }) => (
  <Layout modifiers={['fullscreen']}>
    <Page>
      <Page.Header>
        <Title>Inspecionar JSON</Title>
        <Text>Aqui pode ver o conteúdo da página em formato JSON e as suas edições.</Text>
      </Page.Header>
      <DiffViewer oldCode={oldCode} newCode={newCode} hasEdited={hasEdited} />
    </Page>
  </Layout>
))


const Page = styled.div``;

Page.Header = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
`;

EditorDiff.propTypes = {
  oldCode: PropTypes.string,
  newCode: PropTypes.string,
  hasEdited: PropTypes.bool,
}

EditorDiff.defaultProps = {
  oldCode: '',
  newCode: '',
  hasEdited: false,
}

export default EditorDiff
